import { AppNS } from 'app';
import { API_URL } from 'app/core/config';

import { request } from '../config';

export function apiUpdateUserTerms(): Promise<string> {
  return request(
    {
      baseURL: API_URL,
      url: `users/terms-and-conditions.json`,
      method: 'PATCH',
      data: { properties: { termsAcceptedAt: new Date().toISOString() } },
    },
    (data) => data.user.properties.termsAcceptedAt,
    // old errors format
    { errorType: 'legacy' }
  );
}

export function apiUpdateRoles(userId: string, roles: AppNS.Role[]): Promise<AppNS.Role[]> {
  return request(
    {
      url: `users/${userId}/update-roles.json`,
      method: 'PATCH',
      data: { user: { roles } },
    },
    (data) => data.user.roles
  );
}
